// // Leads page pe ek lead ka card: upar response wala banner, phir naam +
// // status, contact, source/created, aur booking ho to booking ka dabba.
// //
// // Har hissa tabhi banta hai jab uska data lead me ho — company, email,
// // source, appointment na ho to wo hissa dikhta hi nahi.
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import styles from "./PounceLeadCard.module.css";
// import {
//   appointmentLabel,
//   firstContactSeconds,
//   formatWhen,
//   initials,
//   sourceLabel,
//   statusOf,
// } from "../pounceLeadShared";


// // `tone` = is file ki CSS ki status class.
// const STATUS = {
//   new: { label: "New", tone: "statusNeutral" },
//   calling: { label: "Calling", tone: "statusInfo" },
//   booked: { label: "Booked", tone: "statusSuccess" },
//   qualified_no_book: { label: "Hot lead", tone: "statusBrand" },
//   not_interested: { label: "Not interested", tone: "statusNeutral" },
//   no_answer: { label: "No answer", tone: "statusWarning" },
//   bad_number: { label: "Bad number", tone: "statusDanger" },
//   opted_out: { label: "Opted out", tone: "statusDanger" },
//   blocked: { label: "Blocked", tone: "statusDanger" },
//   failed: { label: "Failed", tone: "statusDanger" },
// };

// // Banner ka doosra hissa — lead kahan tak pahunchi.
// const OUTCOME = {
//   booked: "Conversion Complete",
//   qualified_no_book: "Lead Qualified",
//   calling: "Calling Now",
// };

// const PounceLeadCard = ({ lead }) => {
//   const navigate = useNavigate();
//   const status = statusOf(lead);
//   const secs = firstContactSeconds(lead);
//   // "Calling Now" sirf asli call pe — retry ka wait ya hold pe nahi.
//   const outcome = lead.status === "calling" && status.label !== "Calling" ? null : OUTCOME[lead.status];
//   const bannerText = [secs !== null && `Pounced in ${secs.toFixed(1)}s`, outcome]
// const SOURCE_LABELS = { manual: "Added manually", webhook: "Webhook" };

// const formatWhen = (iso) =>
//   new Date(iso).toLocaleString("en-US", {
//     month: "short",
//     day: "numeric",
//     hour: "numeric",
//     minute: "2-digit",
//   });

// const initials = (text) =>
//   String(text || "")
//     .trim()
//     .split(/\s+/)
//     .slice(0, 2)
//     .map((w) => w[0])
//     .join("")
//     .toUpperCase();

// // Lead aane se pehli call tak ke second. `responseSeconds` seedha mile to
// // wahi; warna pehli call ke waqt se nikaalte hain. Waqt na mile, ya jawab ek
// // ghante se bhi baad ka ho, to null — tab "Pounced in …" nahi dikhta.
// const getResponseSeconds = (lead) => {
//   if (typeof lead.responseSeconds === "number") return lead.responseSeconds;
//   const calls = (lead.attempts || []).filter((a) => a.status !== "skipped");
//   const first = [...calls].sort((a, b) => a.attemptNo - b.attemptNo)[0];
//   const startedAt = first?.startedAt || first?.createdAt;
//   if (!startedAt || !lead.createdAt) return null;
//   const secs = (new Date(startedAt) - new Date(lead.createdAt)) / 1000;
//   return secs > 0 && secs < 3600 ? secs : null;
// };

// const PounceLeadCard = ({ lead }) => {
//   const status = STATUS[lead.status] || { label: lead.status, tone: "statusNeutral" };
//   const secs = getResponseSeconds(lead);
//   const bannerText = [secs !== null && `Pounced in ${secs.toFixed(1)}s`, OUTCOME[lead.status]]
//     .filter(Boolean)
//     .join(" · ");

//   const displayName = lead.name || lead.phone;
//   const source = sourceLabel(lead.source);
//   const appointment = lead.appointment;
//   const appt = appointmentLabel(appointment);
//   const appointmentTime = [appt.date, appt.time].filter(Boolean).join(" · ");

//   // Card pe tap → lead detail. Andar ke mailto/tel link apna kaam karein, card na khule.
//   const open = () => navigate(`/leads/${lead.id}`);

//   return (
//     <li
//       className={`${styles.card} ${styles.clickable}`}
//       role="link"
//       tabIndex={0}
//       aria-label={`Open lead ${displayName}`}
//       onClick={(e) => !e.target.closest("a") && open()}
//       onKeyDown={(e) => e.key === "Enter" && e.target === e.currentTarget && open()}
//     >
//   const source = lead.source ? SOURCE_LABELS[lead.source] || lead.source : "";
//   const appointment = lead.appointment || lead.booking || null;
//   // Booking ka waqt: bana-banaya label mile to wahi, warna startTime se.
//   const appointmentTime =
//     appointment?.timeLabel || (appointment?.startTime ? formatWhen(appointment.startTime) : "");

//   return (
//     <li className={styles.card}>
//       {bannerText && (
//         <div className={styles.banner}>
//           <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//             <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8Z" stroke="#fff" strokeWidth="1.8" strokeLinejoin="round" />
//           </svg>
//           <span className={styles.bannerText}>{bannerText}</span>
//           {lead.responseBadge && <span className={styles.bannerBadge}>{lead.responseBadge}</span>}
//         </div>
//       )}

//       <div className={styles.identity}>
//         <span className={styles.avatar} aria-hidden="true">
//           {lead.name ? initials(lead.name) : "#"}
//         </span>
//         <span className={styles.nameBlock}>
//           <span className={styles.nameRow}>
//             <span className={styles.name}>{displayName}</span>
//         {lead.avatar ? (
//           <img className={styles.avatar} src={lead.avatar} alt="" />
//         ) : (
//           <span className={styles.avatar} aria-hidden="true">
//             {lead.name ? initials(lead.name) : "#"}
//           </span>
//         )}
//         <span className={styles.nameBlock}>
//           <span className={styles.nameRow}>
//             <span className={styles.name}>{displayName}</span>
//             {lead.verified && (
//               <svg
//                 className={styles.verified}
//                 width="20"
//                 height="20"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 role="img"
//                 aria-label="Verified"
//               >
//                 <path
//                   d="M12 2.5l2.3 1.9 3-.2.9 2.9 2.5 1.6-1 2.8 1 2.8-2.5 1.6-.9 2.9-3-.2L12 21.5l-2.3-1.9-3 .2-.9-2.9-2.5-1.6 1-2.8-1-2.8 2.5-1.6.9-2.9 3 .2L12 2.5Z"
//                   stroke="#6524EB"
//                   strokeWidth="1.8"
//                   strokeLinejoin="round"
//                 />
//                 <path d="M8.5 12.2l2.3 2.3 4.7-4.8" stroke="#6524EB" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
//               </svg>
//             )}
//           </span>
//           {lead.company && <span className={styles.company}>{lead.company}</span>}
//         </span>
//         <span className={`${styles.status} ${styles[status.tone]}`}>
//           {lead.status === "booked" && (
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//               <rect x="4" y="5" width="16" height="15" rx="3" stroke="currentColor" strokeWidth="2" />
//               <path d="M8 3v4M16 3v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//               <path d="M9 13.5l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//             </svg>
//           )}
//           {status.label}
//         </span>
//       </div>

//       <div className={styles.contact}>
//         {lead.email && (
//           <a className={styles.contactItem} href={`mailto:${lead.email}`}>
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//               <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
//               <path d="M3.5 7l8.5 6 8.5-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//             </svg>
//             <span>{lead.email}</span>
//           </a>
//         )}
//         {/* Naam na ho to number upar naam ki jagah dikh chuka hai — dobara nahi. */}
//         {lead.name && lead.phone && (
//           <a className={styles.contactItem} href={`tel:${lead.phone}`}>
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//               <path
//                 d="M5 4h3l2 5-2.5 1.5a11 11 0 0 0 6 6L15 14l5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinejoin="round"
//               />
//             </svg>
//             <span>{lead.phone}</span>
//           </a>
//         )}
//       </div>

//       {(source || lead.createdAt) && (
//         <div className={styles.meta}>
//           {source && (
//             <span className={styles.source}>
//               <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//                 <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" />
//                 <circle cx="11" cy="11" r="3.5" stroke="currentColor" strokeWidth="2" />
//                 <path d="M14 14l7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//               </svg>
//               <span>
//                 Source: <strong>{source}</strong>
//               </span>
//             </span>
//           )}
//           {lead.createdAt && <span className={styles.created}>Created {formatWhen(lead.createdAt)}</span>}
//         </div>
//       )}

//       {lead.inquiry && <p className={styles.inquiry}>Asked about: {lead.inquiry}</p>}

//       {lead.status === "booked" && (
//         <div className={styles.booking}>
//           <span className={styles.bookingIcon} aria-hidden="true">
//             <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
//               <rect x="4" y="5" width="16" height="15" rx="3" stroke="#fff" strokeWidth="1.8" />
//               <path d="M8 3v4M16 3v4M4 10h16" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
//               <path d="M8 14h2M12 14h2M8 17h2M12 17h2M16 14h.5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
//             </svg>
//           </span>
//           <span className={styles.bookingText}>
//             <span className={styles.bookingHead}>
//               <span className={styles.bookingLabel}>Confirmed booking</span>
//               {appointment?.provider && (
//                 <span className={styles.bookingProvider}>{appointment.provider}</span>
//               )}
//             </span>
//             <span className={styles.bookingTitle}>{appointment?.title || "Appointment booked"}</span>
//             {appointmentTime && <span className={styles.bookingTime}>{appointmentTime}</span>}
//           </span>
//         </div>
//       )}
//     </li>
//   );
// };

// export default PounceLeadCard;



// Leads page pe ek lead ka card: upar response wala banner, phir naam +
// status, contact, source/created, aur booking ho to booking ka dabba.
//
// Har hissa tabhi banta hai jab uska data lead me ho — company, email,
// source, appointment na ho to wo hissa dikhta hi nahi.
import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./PounceLeadCard.module.css";
import {
  appointmentLabel,
  firstContactSeconds,
  formatWhen,
  initials,
  sourceLabel,
  statusOf,
} from "../pounceLeadShared";

// Banner ka doosra hissa — lead kahan tak pahunchi.
const OUTCOME = {
  booked: "Conversion Complete",
  qualified_no_book: "Lead Qualified",
  calling: "Calling Now",
};

const PounceLeadCard = ({ lead }) => {
  const navigate = useNavigate();
  const status = statusOf(lead);
  const secs = firstContactSeconds(lead);
  // "Calling Now" sirf asli call pe — retry ka wait ya hold pe nahi.
  const outcome = lead.status === "calling" && status.label !== "Calling" ? null : OUTCOME[lead.status];
  const bannerText = [secs !== null && `Pounced in ${secs.toFixed(1)}s`, outcome]
    .filter(Boolean)
    .join(" · ");

  const displayName = lead.name || lead.phone;
  const source = sourceLabel(lead.source);
  const appointment = lead.appointment;
  const appt = appointmentLabel(appointment);
  const appointmentTime = [appt.date, appt.time].filter(Boolean).join(" · ");

  // Card pe tap → lead detail. Andar ke mailto/tel link apna kaam karein, card na khule.
  const open = () => navigate(`/leads/${lead.id}`);

  return (
    <li
      className={`${styles.card} ${styles.clickable}`}
      role="link"
      tabIndex={0}
      aria-label={`Open lead ${displayName}`}
      onClick={(e) => !e.target.closest("a") && open()}
      onKeyDown={(e) => e.key === "Enter" && e.target === e.currentTarget && open()}
    >
      {bannerText && (
        <div className={styles.banner}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8Z" stroke="#fff" strokeWidth="1.8" strokeLinejoin="round" />
          </svg>
          <span className={styles.bannerText}>{bannerText}</span>
        </div>
      )}

      <div className={styles.identity}>
        <span className={styles.avatar} aria-hidden="true">
          {lead.name ? initials(lead.name) : "#"}
        </span>
        <span className={styles.nameBlock}>
          <span className={styles.nameRow}>
            <span className={styles.name}>{displayName}</span>
          </span>
          {lead.company && <span className={styles.company}>{lead.company}</span>}
        </span>
        <span className={`${styles.status} ${styles[status.tone]}`}>
          {lead.status === "booked" && (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <rect x="4" y="5" width="16" height="15" rx="3" stroke="currentColor" strokeWidth="2" />
              <path d="M8 3v4M16 3v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              <path d="M9 13.5l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
          {status.label}
        </span>
      </div>

      <div className={styles.contact}>
        {lead.email && (
          <a className={styles.contactItem} href={`mailto:${lead.email}`}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
              <path d="M3.5 7l8.5 6 8.5-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>{lead.email}</span>
          </a>
        )}
        {/* Naam na ho to number upar naam ki jagah dikh chuka hai — dobara nahi. */}
        {lead.name && lead.phone && (
          <a className={styles.contactItem} href={`tel:${lead.phone}`}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M5 4h3l2 5-2.5 1.5a11 11 0 0 0 6 6L15 14l5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinejoin="round"
              />
            </svg>
            <span>{lead.phone}</span>
          </a>
        )}
      </div>

      {(source || lead.createdAt) && (
        <div className={styles.meta}>
          {source && (
            <span className={styles.source}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" />
                <circle cx="11" cy="11" r="3.5" stroke="currentColor" strokeWidth="2" />
                <path d="M14 14l7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
              <span>
                Source: <strong>{source}</strong>
              </span>
            </span>
          )}
          {lead.createdAt && (
            <span className={styles.created}>Created {formatWhen(lead.createdAt, lead.displayTimezone)}</span>
          )}
        </div>
      )}

      {lead.inquiry && <p className={styles.inquiry}>Asked about: {lead.inquiry}</p>}

      {lead.status === "booked" && (
        <div className={styles.booking}>
          <span className={styles.bookingIcon} aria-hidden="true">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
              <rect x="4" y="5" width="16" height="15" rx="3" stroke="#fff" strokeWidth="1.8" />
              <path d="M8 3v4M16 3v4M4 10h16" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
              <path d="M8 14h2M12 14h2M8 17h2M12 17h2M16 14h.5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          </span>
          <span className={styles.bookingText}>
            <span className={styles.bookingHead}>
              <span className={styles.bookingLabel}>Confirmed booking</span>
              {appointment?.provider && (
                <span className={styles.bookingProvider}>{appointment.provider}</span>
              )}
            </span>
            <span className={styles.bookingTitle}>{appointment?.title || "Appointment booked"}</span>
            {appointmentTime && <span className={styles.bookingTime}>{appointmentTime}</span>}
          </span>
        </div>
      )}
    </li>
  );
};
export default PounceLeadCard;